<template>
	<div id="modal-inventory-products-show-open-orders">
		<b-modal :id="modalName" title="Open Orders Detail" scrollable hide-footer size="xl">
            <b-container fluid class="text-center">
                <b-table-simple hover small caption-top bordered responsive>
                    <b-thead head-variant="dark">
                        <b-th>Date</b-th>
                        <b-th>Customer Name</b-th>
                        <b-th>Reference #</b-th>
                        <b-th>Status</b-th>
                        <b-th>QTY</b-th>
                        <b-th>Price</b-th>
                        <b-th>Total</b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-if="line.sale_order.status != 'Closed' && line.sale_order.status != 'Closed'" v-for="line in lines" :key="line.id">
                            <b-td>{{ line.sale_order.date }}</b-td>
                            <b-td>{{ line.sale_order.customer.name }}</b-td>
                            <b-td>{{ line.sale_order.sales_order_number }}</b-td>
                            <b-td>{{ line.sale_order.status }}</b-td>
                            <b-td>{{ line.quantity }}</b-td>
                            <b-td>{{ line.price }}</b-td>
                            <b-td>{{ ((line.price - line.discount) * line.quantity).toFixed(2) }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: [
			'lines'
		],

		data() {
			return {
				modalName: 'modal-inventory-products-show-open-orders'
			}
		},

		methods: {

		},

        mounted() {

        }
	}
</script>

<style lang="scss">
    #modal-inventory-products-show-open-orders {

    }
</style>
